import { Button } from '../Button';
import styles from './ShowMoreButton.module.scss';

interface IShowMoreButtonProps {
  onClick: () => void;
  totalCount: number;
  visibleCount: number;
  text?: string;
}

export const ShowMoreButton = ({ onClick, totalCount, visibleCount, text }: IShowMoreButtonProps) => {
  return (
    <div className={styles.ShowMoreButtonWrapper}>
      <Button
        className={styles.ShowMoreButton}
        text={text || `Показать еще (показано ${visibleCount} из ${totalCount})`}
        type="button"
        variant="link"
        color="primary"
        onClick={onClick}
      />
    </div>
  );
};
